import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';

export const HOME_EASE = [0.22, 1, 0.36, 1];

const VIEWPORT = { once: true, amount: 0.16, margin: '0px 0px -8% 0px' };

function hiddenFrom(from) {
  if (from === 'left') return { opacity: 0, x: -28, y: 8 };
  if (from === 'right') return { opacity: 0, x: 28, y: 8 };
  return { opacity: 0, y: 24 };
}

export function HomeReveal({
  as = 'div',
  children,
  className,
  delay = 0,
  from = 'up',
  ...rest
}) {
  const reduce = useReducedMotion();
  const MotionTag = motion[as] || motion.div;

  if (reduce) {
    const Tag = as;
    return (
      <Tag className={className} {...rest}>
        {children}
      </Tag>
    );
  }

  return (
    <MotionTag
      className={className}
      initial={hiddenFrom(from)}
      whileInView={{ opacity: 1, x: 0, y: 0 }}
      viewport={VIEWPORT}
      transition={{ duration: 0.65, delay, ease: HOME_EASE }}
      {...rest}
    >
      {children}
    </MotionTag>
  );
}

const FLOAT_EASE = [0.37, 0, 0.63, 1];

export function HomeFloat({
  className,
  cardClassName,
  enterDelay = 0,
  drift,
  inView = false,
  children,
}) {
  const reduce = useReducedMotion();
  const enterProps = inView
    ? {
        initial: reduce ? false : { opacity: 0, y: 16 },
        whileInView: { opacity: 1, y: 0 },
        viewport: VIEWPORT,
      }
    : {
        initial: reduce ? false : { opacity: 0, y: 12 },
        animate: { opacity: 1, y: 0 },
      };

  return (
    <motion.div
      className={`home-float ${className}`}
      aria-hidden="true"
      {...enterProps}
      transition={{ duration: 0.55, delay: enterDelay, ease: HOME_EASE }}
    >
      <motion.article
        className={`home-float-card ${cardClassName}`}
        style={{ willChange: reduce ? undefined : 'transform' }}
        transformTemplate={({ x, y }) => `translate3d(${x}, ${y}, 0)`}
        animate={
          reduce
            ? undefined
            : {
                x: [0, drift.x],
                y: [0, drift.y],
              }
        }
        transition={
          reduce
            ? undefined
            : {
                x: {
                  duration: drift.durationX || drift.duration * 1.2,
                  delay: enterDelay + 0.45,
                  repeat: Infinity,
                  repeatType: 'mirror',
                  ease: FLOAT_EASE,
                },
                y: {
                  duration: drift.duration,
                  delay: enterDelay + 0.45,
                  repeat: Infinity,
                  repeatType: 'mirror',
                  ease: FLOAT_EASE,
                },
              }
        }
      >
        {children}
      </motion.article>
    </motion.div>
  );
}
